/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Delete_ConfirmInputs */

const en_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, delete it`)
};

const fr_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, supprimer`)
};

const de_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, lösch es.`)
};

const it_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, eliminalo`)
};

const ru_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, удалите это.`)
};

const es_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, bórralo`)
};

const zh_cn2_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，删除它`)
};

const ja_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、削除します`)
};

const hi_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हां, इसे हटा दें`)
};

const pt_pt2_explorer_info_delete_confirm = /** @type {(inputs: Explorer_Info_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, apague-o.`)
};

/**
* | output |
* | --- |
* | "Yes, delete it" |
*
* @param {Explorer_Info_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_delete_confirm = /** @type {((inputs?: Explorer_Info_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_delete_confirm(inputs)
	if (locale === "de") return de_explorer_info_delete_confirm(inputs)
	if (locale === "it") return it_explorer_info_delete_confirm(inputs)
	if (locale === "ru") return ru_explorer_info_delete_confirm(inputs)
	if (locale === "es") return es_explorer_info_delete_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_delete_confirm(inputs)
	if (locale === "ja") return ja_explorer_info_delete_confirm(inputs)
	if (locale === "hi") return hi_explorer_info_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_delete_confirm(inputs)
	return en_explorer_info_delete_confirm(inputs)
});